import React, { forwardRef } from 'react';

import { useSelector } from 'react-redux';

import Dropdown from '../dropdown';

const normalizeItems = ({ _id, title }) => ({ _id, title });

const ProductsDropdown = forwardRef((props, ref) => {
  const isLoaded = useSelector((state) => state.products.isLoaded);
  const defaultItems = useSelector((state) => state.products.items.map(normalizeItems));

  const {
    items = defaultItems,
    inProgress = false,
    ...rest
  } = props;

  return (
    <Dropdown
      ref={ref}
      {...rest}
      additionalClass="products-dropdown"
      visibleItemsLength={8}
      type="keyword"
      items={items}
      isItemsLoaded={isLoaded}
      inProgress={!isLoaded || inProgress}
    />
  );
});

export default ProductsDropdown;
